namespace Areas.Dialog {
    "use strict";

    export class BuildingImageDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("BuildingImage", closeHandler, parameters, 
            () => {
                const uploader = $("#fileUploaderControl").dxFileUploader("instance");
                let url: any = uploader.option("uploadUrl");
        
                url = updateQueryStringParameter(url, "buildingId", this.parameters.buildingId);
                url = updateQueryStringParameter(url, "buildingImageId", this.parameters.buildingImageId);
                
                uploader.option("uploadUrl", url); 
                uploader.option("multiple", this.parameters.allowMultipleUploads);

                if (!this.parameters.allowMultipleUploads) {
                    this.popup.option("title", "Replace Building Image");
                    uploader.option("selectButtonText", "Select Image");
                    this.popup.option("maxWidth", 400);
                    this.popup.option("maxHeight", 350);
                }
            });
        }

        protected ok = (e: any) => {            
            this.close(DialogResult.Ok, null);             
        } 
       
    }
    
}